export default __webpack_public_path__ + "static/Pure-Plank-6ab45fef1953a122beac7d4413605b20.webp";